export default __webpack_public_path__ + "static/media/poppins-v20-latin-regular.405055dd.woff2";